<script lang="ts">
  import type { Snippet } from "svelte";
  import Layout from './Layout.svelte';
  import TripSubNav from '../navigation/TripSubNav.svelte';
  import type { Trip } from '../../lib/types';

  let {
    trip,
    user = null,
    currentPage = "overview",
    children,
  }: {
    trip: Trip & { isPublic?: boolean };
    user?: { id: string; name: string; email: string; avatarUrl?: string } | null;
    currentPage?: string;
    children?: Snippet;
  } = $props();
</script>

<Layout {user}>
  <div class="min-h-screen bg-gray-50">
    <!-- Trip Header -->
    <div class="bg-white border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">{trip.name}</h1>
            {#if trip.description}
              <p class="text-sm text-gray-600 mt-1">{trip.description}</p>
            {/if}
          </div>
        </div>
      </div>
    </div>

    <!-- Trip Sub Navigation -->
    <TripSubNav {trip} {currentPage} />

    <!-- Page Content -->
    <div class="container mx-auto px-4 py-6">
      {@render children?.()}
    </div>
  </div>
</Layout>
